import { supabase } from '../lib/supabase';

/**
 * Fetch max_credits for a given tier from subscription_plans table.
 * Matches by tier name (free/solo/pro/team) against the monthly (or one-time) plan.
 * Falls back to 10 if not found.
 */
export async function getMaxCreditsForTier(tier) {
  try {
    const { data, error } = await supabase
      .from('subscription_plans')
      .select('max_credits, name, billing_cycle')
      .eq('is_active', true);

    if (error || !data) return 10;

    const lowerTier = (tier || 'free').toLowerCase();

    // Find the monthly (or one-time for free) plan that matches this tier
    const match = data.find((p) => {
      const name = (p.name || '').toLowerCase();
      if (lowerTier === 'free') return name.includes('free');
      return name.includes(lowerTier) && p.billing_cycle === 'monthly';
    });

    return match?.max_credits || 10;
  } catch {
    return 10;
  }
}
